import getMarket from '../utils/getMarket';

export const LOCATION_SEARCH_DATA_LOCAL_STORAGE_KEY = 'locationSearchData';
export const LOCATION_SEARCH_DATA_CHANGE_EVENT = 'LOCATION_SEARCH_DATA_CHANGED';
export const SELECTED_FILTERS_LOCAL_STORAGE_KEY = 'selectedFilters-v5';
export const LOCATION_SEARCH_MODAL_OPEN_EVENT = 'LOCATION_SEARCH_MODAL_OPEN';

export const MARKET = getMarket();

// DETAILS PAGE URLS
export const REDIRECT_TO_STAGING = window.location.pathname.includes('test_pages');
export const REDIRECT_TO_QA_PAGE = window.location.host.includes('qa.audiusa');
export const IS_HEADLESS =
  !window.location.host.includes('audiusa.com') &&
  !window.location.host.includes('audi.ca') &&
  !window.location.host.includes('localhost');

const DETAILS_URL_USA_STAGING = REDIRECT_TO_QA_PAGE
  ? `https://${window.location.host}/us/web/en/test_pages/vehicles-new.html`
  : `https://${window.location.host}/us/web/en/test_pages/inventory/vehicle-staging.html`;

export const DETAILS_URL_USA_EN = REDIRECT_TO_STAGING
  ? DETAILS_URL_USA_STAGING
  : `https://${window.location.host}/us/web/en/inventory/vehicle.html`;

export const DETAILS_URL_CAN_EN = REDIRECT_TO_STAGING
  ? `https://${window.location.host}/ca/web/en/test_pages/inventory/vehicle-staging.html`
  : `https://${window.location.host}/ca/web/en/inventory/vehicle.html`;

export const DETAILS_URL_CAN_FR = REDIRECT_TO_STAGING
  ? `https://${window.location.host}/ca/web/fr/test_pages/inventory/vehicle-staging.html`
  : `https://${window.location.host}/ca/web/fr/inventory/vehicle.html`;

export const HEADLESS_DETAILS_URL = `${window.location.origin}${window.location.pathname}vehicle/`;

const getT3Url = () => {
  let url = window.location.href;
  const htmlExtension = '.html';
  const queryParamIndex = url.indexOf('?');

  if (queryParamIndex !== -1) {
    // If there are query parameters, remove them
    url = url.slice(0, queryParamIndex);
  }

  if (url.endsWith(htmlExtension)) {
    return url.slice(0, -htmlExtension.length);
  }

  return url; // If the URL doesn't end with ".html", return it as-is
};

export const DETAILS_URL_USA_EN_T3 = `${getT3Url()}/vehicle.html`;

// VERSION QUERY PARAM
export const QUERY_VERSION = new URLSearchParams(window.location.search).get('version') ?? '2.0.0';

// TODO FIXME remove this logi at the end of April,
// it's a temporary solution to hide pipeline inventory
// for specific dealerships in the Canadian market
const dealer = new URLSearchParams(window.location.search).get('dealer');

// TODO FIXME remove DONT_SHOW_PIPELINE_INVENTORY from other files
export const DONT_SHOW_PIPELINE_INVENTORY = [
  // Audi Glenmore
  '91520',
  // Audi Kingston
  '93061',
  // Audi Halifax
  '95863',
  // Audi Sudbury
  '93127',
].includes(dealer ?? '');

export const VEHICLE_FALLBACK_IMAGE =
  'https://nar.media.audi.com/is/image/audinar/country/us/en/inventory/assets/vehicle-fallback-image.png';
